function isBrowser() {
    return typeof window !== 'undefined'
}

export { isBrowser }
export default isBrowser
